import { useFileUploader } from "../../modules/Files/hooks/useFileUploader.js";
import { openFilePicker } from "../../modules/Files/utils/open-file-picker.js";
import { LogoImage } from "../../modules/Files/shared/LogoImage.js";
import { useEffect } from "react";
import { Button, Icon, Loading } from "@therms/atalaya";
import { IoClose } from "react-icons/io5";
import { IoMdAdd } from "react-icons/io";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { MdEdit } from "react-icons/md";
import { useFormikContext } from "formik";
//#region src/components/FormikFields/FormikSingleImageFilePicker.tsx
function FormikSingleImageFilePicker({ defaultImageUrl, maxHeight, maxWidth, name, onComplete }) {
	const form = useFormikContext();
	const { allUploadsComplete, files, removeAllFiles, replaceAllFiles } = useFileUploader();
	const logoUrl = files[0]?.imagePreviewUrl || form?.values?.[name];
	const newLogoUrl = files[0]?.accessUrl;
	useEffect(() => {
		if (newLogoUrl !== form.values?.[name]) {
			form.setFieldValue(name, newLogoUrl);
			onComplete?.(newLogoUrl);
		}
	}, [newLogoUrl, onComplete]);
	const replaceImage = () => openFilePicker(replaceAllFiles, {
		accept: "image/*",
		multiple: false
	});
	return /* @__PURE__ */ jsxs("div", {
		className: "relative",
		children: [
			!allUploadsComplete && /* @__PURE__ */ jsx(Loading, {
				overlay: true,
				size: "sm"
			}),
			/* @__PURE__ */ jsx(LogoImage, {
				maxHeight,
				maxWidth,
				url: logoUrl || defaultImageUrl
			}),
			allUploadsComplete && (logoUrl ? /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("div", {
				className: "bg-surface-strong absolute right-0 top-0 opacity-70",
				children: /* @__PURE__ */ jsx(Button, {
					borderRadius: "none",
					className: "text-sm",
					onClick: removeAllFiles,
					subtle: true,
					variant: "critical",
					children: /* @__PURE__ */ jsx(Icon, {
						Icon: IoClose,
						size: "xs"
					})
				})
			}), /* @__PURE__ */ jsx("div", {
				className: "bg-surface-strong absolute bottom-0 right-0 opacity-70",
				children: /* @__PURE__ */ jsxs(Button, {
					borderRadius: "none",
					className: "text-sm",
					onClick: replaceImage,
					subtle: true,
					children: [
						/* @__PURE__ */ jsx(Icon, {
							className: "mr-xxs",
							Icon: MdEdit,
							size: "xs"
						}),
						" ",
						/* @__PURE__ */ jsx("span", { children: "Edit" })
					]
				})
			})] }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("div", { className: "bg-surface-strong absolute inset-0 rounded opacity-90" }), /* @__PURE__ */ jsx(Button, {
				className: "absolute inset-0",
				onClick: replaceImage,
				subtle: true,
				variant: "main",
				children: /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(Icon, { Icon: IoMdAdd }), /* @__PURE__ */ jsx("div", {
					className: "text-md",
					children: "Add Image"
				})] })
			})] }))
		]
	});
}
//#endregion
export { FormikSingleImageFilePicker };

//# sourceMappingURL=FormikSingleImageFilePicker.js.map